// extracted by mini-css-extract-plugin
export default {"controller":"Input_controller__lBQzd"};